import api from './api';

const getAll = (pagination, filter, sortColumn) => api.get('/region', {
    pageNum: pagination.currentPage - 1,
    pageLength: pagination.itemsPerPage,
    active: filter.active,
    search: filter.search,
    provinceId: filter.provinceId,
    sortBy: sortColumn.sortByColumn,
    orderBy: sortColumn.orderBy
}).then(response => response.data);

const getById = (id) => api.get(`/region/${id}`).then(response => {
    return response.data
});

const create = (data) => api.post('/region', data).then(response => {
    return response.data
});

const remove = (id) => api.delete(`/region/${id}`).then(response => {
    return response.data
});

const update = (id, data) => api.put(`/region/${id}`, data).then(response => {
    return response.data
});

const getByProvinceId = (id) => api.get('/region/province', {
    provinceId: id
}).then(response => response.data);

const getList = () => api.get('/region/list').then(response => response.data);

const RegionService = {
    getAll,
    getByProvinceId,
    getList,
    getById,
    create,
    update,
    remove
}

export default RegionService;